import React from 'react';
import styled from 'styled-components';

import loader from './loader.gif';

export default function Loader() {
  return (
    <LoaderContainer>
      <img src={ loader } alt="loading..." />
    </LoaderContainer>
  );
}


const LoaderContainer = styled.div`
  width: 100%;
  text-align: center;

  img {
    width: 100px
  }
`;
